<template>
  <v-container class="no-margins">
    <h1 class="welcome">{{ $t('welcome.hello') }} {{ this.currentUser.firstName }}!</h1>

    <template v-if="underage">
      <MessageBox class="mb-7" type="info">
        <h6 class="boxtitle">{{ $t('welcome.underage-notallowed') }}</h6>
        <p>{{ $t('welcome.underage-notallowed-info') }}</p>
        <p>
          <a :href="links.login.minor" target="_blank">{{ $t('welcome.underage-link') }}</a>
        </p>
      </MessageBox>
    </template>

    <template v-else>
      <p>{{$t('welcome.loggedin-text')}}</p>
      <MessageBox class="mb-7" type="info">
        <p>{{$t('welcome.loggedin-text2')}}</p>
        <p>
          <a
            :href="links.main.bynPolicies"
            target="_blank"
          >{{ $t('welcome.loggedin-link') }}</a>
        </p>
      </MessageBox>

      <MessageBox class="mb-7" type="info">
        <h6 class="font-weight-bold">{{$t('welcome.text4')}}</h6>
        <p class="font-weight-bold">{{$t('welcome.loggedin-text4')}}</p>
      </MessageBox>

      <NextButton
        class="mt-7"
        @click="$nextTick(()=>{$router.push({name: 'Register'})})"
      >{{$t('tour.next')}}</NextButton>
    </template>
  </v-container>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import NextButton from '@/components/Common/NextButton'
import MessageBox from '@/components/Common/MessageBox'
const SugarDate = require('sugar/date')

export default {
  name: 'NotRegistered',
  data() {
    return {
      links:require('../../lib/external-links.json'),
    }
  },
  computed: {
    ...mapGetters('currentuser', ['currentUser']),

    underage() {
      let age = 18
      try {
        const now = SugarDate.Date('now')
        const birthdate = SugarDate.Date(this.currentUser.personalNumber.substring(0, 8))
        age = birthdate.yearsAgo(now).raw
      } catch (e) {
        // Nada
      }
      return age < 18
    }
  },

  components: {
    NextButton,
    MessageBox
  }
}
</script>

<style>
</style>